const SITE_URL = "https://atriumheartbeat.com";

const LINKS = [
  { label: "About Us", href: `${SITE_URL}/about` },
  { label: "Privacy Policy", href: `${SITE_URL}/privacy-policy` },
  { label: "Terms of Service", href: `${SITE_URL}/heartbeat/terms` },
];

/** Admin footer: copyright and links to the Atrium marketing site. */
const Footer = () => (
  <footer className="flex flex-col items-center justify-between gap-3 border-t border-line/60 px-4 py-6 text-sm text-fg-muted md:flex-row md:px-6">
    <p>© {new Date().getFullYear()} Atrium. All rights reserved.</p>
    <ul className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
      {LINKS.map(({ label, href }) => (
        <li key={label}>
          <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className="focus-ring rounded font-medium transition-colors hover:text-fg"
          >
            {label}
          </a>
        </li>
      ))}
    </ul>
  </footer>
);

export default Footer;
